export default "__VITE_ASSET__BzxmQ4On__"